import { render, staticRenderFns } from "./BlockPreview.vue?vue&type=template&id=69f7d0ca&scoped=true&"
import script from "./BlockPreview.vue?vue&type=script&lang=js&"
export * from "./BlockPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlockPreview.vue?vue&type=style&index=0&id=69f7d0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f7d0ca",
  null
  
)

export default component.exports